/**
 * GraphQL queries for Shopify blog articles
 */

/**
 * Optimized query to get blog articles by blog handle
 * Supports optional query parameters and removes edge/node patterns
 */
export const GET_BLOG_ARTICLES = `
  query getBlogArticles(
    $blogHandle: String!,
    $limit: Int = 10,
    $after: String,
    $before: String,
    $query: String,
    $sortKey: ArticleSortKeys = PUBLISHED_AT,
    $reverse: Boolean = false
  ) {
    blog(handle: $blogHandle) {
      title
      seo {
        title
        description
      }
      articles(
        first: $limit,
        after: $after,
        before: $before,
        query: $query,
        sortKey: $sortKey,
        reverse: $reverse
      ) {
        nodes {
          id
          handle
          title
          content
          excerpt
          publishedAt
          tags
          image {
            url
            altText
          }
          seo {
            title
            description
          }
          author {
            name
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
`;

/**
 * Optimized query to get a single blog article by handle
 */
export const GET_ARTICLE_BY_HANDLE = `
  query getArticleByHandle($blogHandle: String!, $articleHandle: String!) {
    blog(handle: $blogHandle) {
      title
      seo {
        title
        description
      }
      articleByHandle(handle: $articleHandle) {
        id
        title
        handle
        content
        contentHtml
        excerpt
        publishedAt
        tags
        image {
          url
          altText
        }
        seo {
          title
          description
        }
        author {
          name
        }
      }
    }
  }
`;

/**
 * Optimized query to get trending blog articles
 * Supports optional limit and custom query
 */
export const GET_TRENDING_ARTICLES = `
  query getTrendingArticles(
    $handle: String!,
    $limit: Int = 5,
    $query: String = "tag:trending-this-week"
  ) {
    blog(handle: $handle) {
      articles(first: $limit, query: $query) {
        nodes {
          id
          title
          handle
          publishedAt
          tags
          excerpt
          content
          image {
            url
            altText
          }
          seo {
            title
            description
          }
          author {
            name
          }
        }
      }
    }
  }
`;

/**
 * Optimized query to get all articles from all blogs
 * Supports optional parameters and removes edge/node patterns
 */
export const GET_ARTICLES_QUERY = `
  query GetArticles(
    $blogLimit: Int = 10,
    $articleLimit: Int = 50,
    $query: String,
    $sortKey: ArticleSortKeys = PUBLISHED_AT,
    $reverse: Boolean = false
  ) {
    blogs(first: $blogLimit) {
      nodes {
        id
        title
        handle
        articles(
          first: $articleLimit,
          query: $query,
          sortKey: $sortKey,
          reverse: $reverse
        ) {
          nodes {
            id
            title
            handle
            excerpt
            content
            contentHtml
            publishedAt
            tags
            image {
              url
              altText
            }
            author {
              name
            }
            seo {
              title
              description
            }
          }
        }
      }
    }
  }
`;
